
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.25 7h-5.5V4h-.5l-4 4 4 4h.5V9h5.5c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5h-5.5v2h5.5c3.584 0 6.5-2.916 6.5-6.5S16.834 7 13.25 7z","fill":"currentColor"}})])
          )
        }
      }
    